// test2947
(2947 && 0);
